import React, { useEffect, useRef } from 'react';
import Carousel from 'react-owl-carousel2';

export default function OwlCarousel(props) {
    const { adClass, carouselOptions } = props;
    const carouselRef = useRef(null);

    useEffect(() => {
        const currentCarousel = carouselRef.current;
        const handleDotClick = (e) => {
            currentCarousel.goTo(e.currentTarget.index());
        };

        if (
            props.children &&
            (props.children.length > 0 || (props.children && props.children.length === undefined)) &&
            currentCarousel?.props?.className?.indexOf('owl-quickview') > -1
        ) {
            let dots;

            if (document.querySelector("#owl-dots .carousel-dot")) {
                if (!document.querySelector("#owl-dots .carousel-dot.active"))
                    document.querySelectorAll("#owl-dots .carousel-dot")[0].classList.add("active");
                dots = document.querySelectorAll('#owl-dots .carousel-dot');
                for (let i = 0; i < dots.length; i++) {
                    dots[i].addEventListener("click", handleDotClick);
                }
            }
        }

        return () => {
            const cleanupCarousel = currentCarousel;
            if (
                cleanupCarousel &&
                (props.children.length > 0 || (props.children && props.children.length === undefined)) &&
                cleanupCarousel.props.className.indexOf('owl-quickview') > -1
            ) {
                let dots;

                if (document.querySelector("#owl-dots .carousel-dot")) {
                    if (!document.querySelector("#owl-dots .carousel-dot.active"))
                        document.querySelectorAll("#owl-dots .carousel-dot")[0].classList.add("active");
                    dots = document.querySelectorAll('#owl-dots .carousel-dot');
                    for (let i = 0; i < dots.length; i++) {
                        dots[i].removeEventListener("click", handleDotClick);
                    }
                }
            }
        };
    }, [props.children]);

    const events = {
        onTranslate: function (e) {
            if (!e.target) return;
            if (e.target.closest(".owl-quickview")) {
                document.querySelector("#owl-dots").querySelector(".active").classList.remove("active");
                document.querySelector("#owl-dots").children[e.page.index].classList.add("active");
            }
        },
    };

    let slider_default_options = {
        items: 1,
        loop: false,
        margin: 0,
        responsiveClass: "true",
        nav: true,
        navText: ['<i class="icon-angle-left">', '<i class="icon-angle-right">'],
        dots: true,
        smartSpeed: 400,
        autoplay: false,
        responsive: {
            320: {
                nav: false,
            },
            375: {
                nav: false,
            },
        },
    };

    let res = Object.assign({}, slider_default_options, carouselOptions);

    return (
        props.children !== undefined || null ?
            props.children.length > 0 || (props.children && props.children.length === undefined) ?
                <Carousel className={`owl-carousel ${adClass}`} options={res} events={events} ref={carouselRef}>
                    {props.children}
                </Carousel>
                : ""
            : ""
    );
}
